import type { Lang } from '@/hooks/useLang'

interface FooterProps {
  lang: Lang
}

export default function Footer({ lang: _lang }: FooterProps) {
  return (
    <footer className="w-full py-12 px-8 bg-slate-950 border-t border-primary-container/20">
      <div className="w-full flex flex-col md:flex-row justify-between items-center gap-6">

        {/* Brand */}
        <div className="flex items-center gap-4">
          <span className="text-primary-container font-bold font-headline tracking-tighter text-lg uppercase">
            ROBOT.FRIC.LINK
          </span>
          <div className="hidden md:block h-4 w-px bg-surface-container-high" />
          <span className="font-body text-[10px] tracking-[0.2em] font-light text-on-surface-variant/40 uppercase">
            ALL SYSTEMS OPERATIONAL.
          </span>
        </div>

        {/* Links */}
        <nav className="flex flex-wrap justify-center gap-8">
          {[
            { label: 'LEGAL', href: '/legal' },
            { label: 'SYSTEM_STATUS', href: '/status' },
            { label: 'DOCUMENTATION', href: '/docs' },
          ].map(({ label, href }) => (
            <a
              key={label}
              href={href}
              className="font-body text-[10px] tracking-[0.2em] font-light text-on-surface-variant/40 hover:text-secondary transition-colors uppercase"
            >
              {label}
            </a>
          ))}
        </nav>

        {/* Copyright */}
        <div className="text-[10px] tracking-[0.2em] font-light text-on-surface-variant/30 uppercase font-body">
          © {new Date().getFullYear()} ROBOT.FRIC.LINK
        </div>

      </div>
    </footer>
  )
}
